import { RecruitmentTypeDto } from '@/api/generated';

export type ProcessTemplatesTranslation = {
  deleteConfirmation: string;
  form: {
    addNewRedFlag: string;
    budget: string;
    cancel: string;
    candidateScreening: string;
    deleteKeywordConfirmation: string;
    description: string;
    descriptionWeightHint: string;
    generalInfo: string;
    jobDescription: string;
    keywordDuplicate: string;
    keywords: string;
    keywordsHelp: string;
    keywordsPlaceholder: string;
    keywordTooShort: string;
    locationType: string;
    locationTypes: {
      HYBRID: string;
      OFFICE: string;
      REMOTE: string;
    };
    name: string;
    noKeywords: string;
    none: string;
    positionDetails: string;
    recruitmentType: string;
    recruitmentTypes: Record<RecruitmentTypeDto, string>;
    redFlagDuplicate: string;
    redFlagsHelp: string;
    redFlagsPlaceholder: string;
    redFlagTooShort: string;
    save: string;
    tolerance: string;
  };
  noTemplatesFound: string;
  selectOrAddTemplate: string;
  title: string;
  unsavedChangesDialog: {
    cancel: string;
    content: string;
    save: string;
    title: string;
  };
};

export const processTemplatesTranslation: ProcessTemplatesTranslation = {
  deleteConfirmation: 'Are you sure you want to delete this process template?',
  form: {
    addNewRedFlag: 'Add new red flag',
    budget: 'Budget',
    cancel: 'Cancel',
    candidateScreening: 'Candidate Screening',
    deleteKeywordConfirmation: 'Are you sure you want to delete this keyword?',
    description: 'Description',
    descriptionWeightHint:
      'You can optionally set a requirement weight by adding [w:X] at the end, where X is a number from 1 to 5, for example "JavaScript [w:5]". You can use this marker for any number of requirements.',
    generalInfo: 'General Info',
    jobDescription: 'Job Description',
    keywordDuplicate: 'This keyword already exists',
    keywords: 'Keywords',
    keywordsHelp: 'Keywords for auto-detecting this template',
    keywordsPlaceholder: 'Enter keyword (e.g., sales, consultant)',
    keywordTooShort: 'Keyword must be at least 2 characters long',
    locationType: 'Location type',
    locationTypes: {
      HYBRID: 'Hybrid',
      OFFICE: 'Office',
      REMOTE: 'Remote',
    },
    name: 'Name',
    noKeywords: 'No keywords added yet',
    none: 'None',
    positionDetails: 'Position Details',
    recruitmentType: 'Template Type',
    recruitmentTypes: {
      B2C: 'B2C',
      REGULAR: 'Regular',
    },
    redFlagDuplicate: 'This red flag already exists',
    redFlagsHelp:
      'List the red flags below that should be considered when matching candidates to the process.',
    redFlagsPlaceholder: 'write the red flag',
    redFlagTooShort: 'Red flag must be at least 2 characters long',
    save: 'Save',
    tolerance: 'Tolerance',
  },
  noTemplatesFound: 'No templates found.',
  selectOrAddTemplate: 'Select a template from the list or add a new one.',
  title: 'Process Templates',
  unsavedChangesDialog: {
    cancel: 'Cancel',
    content: 'You have unsaved changes. Save them before leaving this view.',
    save: 'Save',
    title: 'Unsaved changes',
  },
};
